/**
 * 企业问题
 * @author liuys
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async getQuestionTree() {
    return request(api.answer.QUESTIONTYPE + '/all', METHOD.GET);
  },
  async saveQuestionTreeDetail(params) {
    return request(api.answer.QUESTIONTYPE, METHOD.POST, params);
  },
  async getQuestionTreeDetail(keyId) {
    return request(api.answer.QUESTIONTYPE + "/" + keyId, METHOD.GET);
  },
  async delQuestionTree(params) {
    return request(api.answer.QUESTIONTYPE + '/delete?questionTypeId=' + params, METHOD.GET);
  },
  async getKeyWords() {
    return request(api.answer.KEYWORDS + '/all', METHOD.GET);
  },
  async saveFormDetail(params) {
    return request(api.answer.QUESTION, METHOD.POST, params);
  },
  async getFormDetail(keyId) {
    return request(api.answer.QUESTION + "/" + keyId, METHOD.GET);
  }
}

export default {dataApi}